<template>
<div class="modal fade" id="modalManageCompanyTags" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="title-modal">Gerenciar tags de empresa</h4>
        <p class="subtitle-modal">Catálogo global. Tags aparecem em todas as empresas e podem ser atribuídas/removidas individualmente.</p>
      </div>

      <div class="modal-body">
        <!-- Nova tag -->
        <div class="form-row">
          <input type="text" v-model="newTag.name" placeholder="Nome da tag" />
          <input type="color" v-model="newTag.color" />
          <input type="text" v-model="newTag.description" placeholder="Descrição (tooltip)" class="grow" />
          <button class="btn-add" @click="create" :disabled="!newTag.name">Criar</button>
        </div>

        <hr/>

        <!-- Lista -->
        <table class="tag-table" v-if="tags.length">
          <thead>
            <tr><th>Tag</th><th>Cor</th><th>Descrição</th><th></th></tr>
          </thead>
          <tbody>
            <tr v-for="t in tags" :key="t.id">
              <td>
                <span class="chip-preview" :style="{ backgroundColor: t.color }">{{ t.name }}</span>
                <input v-if="editing[t.id]" v-model="t.name" class="inline-input" />
              </td>
              <td>
                <input v-if="editing[t.id]" type="color" v-model="t.color" />
                <span v-else class="color-swatch" :style="{ backgroundColor: t.color }"></span>
              </td>
              <td>
                <input v-if="editing[t.id]" v-model="t.description" class="inline-input grow" />
                <span v-else>{{ t.description }}</span>
              </td>
              <td class="actions">
                <button v-if="!editing[t.id]" class="btn-link" @click="$set(editing, t.id, true)">Editar</button>
                <button v-else class="btn-link" @click="save(t)">Salvar</button>
                <button class="btn-link danger" @click="remove(t)">Excluir</button>
              </td>
            </tr>
          </tbody>
        </table>

        <p v-else class="empty">Nenhuma tag criada ainda.</p>
      </div>

      <div class="modal-footer">
        <button @click="closeModal" class="close-btn">Fechar</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { COMPANY_TAGS } from "../../../urlConfig";
import { REQUEST_SERVICE } from "../../../requestConfig";
import swal from "sweetalert";

export default {
  name: "modalManageCompanyTags",
  data() {
    return {
      tags: [],
      editing: {},
      newTag: { name: "", color: "#3598dc", description: "" }
    };
  },
  mounted() {
    this.load();
    $("#modalManageCompanyTags").on("shown.bs.modal", () => this.load());
  },
  methods: {
    load() {
      REQUEST_SERVICE.get(COMPANY_TAGS).then((r) => { this.tags = r.data || []; });
    },
    create() {
      if (!this.newTag.name) return;
      REQUEST_SERVICE.post(COMPANY_TAGS, this.newTag)
        .then(() => {
          this.newTag = { name: "", color: "#3598dc", description: "" };
          this.load();
        })
        .catch(() => swal("Aviso", "Falha ao criar tag.", "error"));
    },
    save(t) {
      REQUEST_SERVICE.requestContext("PUT", `${COMPANY_TAGS}/${t.id}`, null, t)
        .then(() => { this.$set(this.editing, t.id, false); this.load(); })
        .catch(() => swal("Aviso", "Falha ao salvar.", "error"));
    },
    remove(t) {
      swal({
        title: "Excluir tag?",
        text: `A tag "${t.name}" será removida e desatribuída de todas as empresas.`,
        buttons: ["Cancelar", "Excluir"],
        dangerMode: true
      }).then((ok) => {
        if (!ok) return;
        REQUEST_SERVICE.requestContext("DELETE", `${COMPANY_TAGS}/${t.id}`, null)
          .then(() => this.load())
          .catch(() => swal("Aviso", "Falha ao excluir.", "error"));
      });
    },
    closeModal() { $("#modalManageCompanyTags").modal("toggle"); }
  }
};
</script>

<style lang="scss">
#modalManageCompanyTags {
  .modal-header { padding: 15px 15px 0; border-bottom: none; }
  .title-modal { text-align: center; font-weight: bold; padding-top: 10px; letter-spacing: 1px; text-transform: uppercase; }
  .subtitle-modal { text-align: center; color: #777; font-size: 13px; padding: 0 30px; margin-top: 8px; }
  .modal-body { padding: 20px 40px; }

  .form-row { display: flex; gap: 8px; align-items: center; margin-bottom: 8px;
    input[type="text"] { border: 1px solid #ccc; border-radius: 4px; padding: 6px 10px; flex: 0 0 200px; }
    input[type="color"] { width: 40px; height: 32px; border: none; padding: 0; }
    .grow { flex: 1; }
    .btn-add { background: #27ae60; color: #fff; border: none; padding: 6px 18px; border-radius: 4px; cursor: pointer; }
    .btn-add:disabled { opacity: 0.5; cursor: not-allowed; }
  }

  .tag-table { width: 100%; border-collapse: collapse; font-size: 13px;
    th, td { padding: 8px; border-bottom: 1px solid #eee; vertical-align: middle; }
    th { color: #555; font-weight: 600; }
    .chip-preview { color: #fff; padding: 3px 10px; border-radius: 12px; font-weight: 600; font-size: 11px; }
    .color-swatch { display: inline-block; width: 22px; height: 22px; border-radius: 4px; border: 1px solid #ddd; }
    .inline-input { border: 1px solid #ccc; border-radius: 4px; padding: 4px 8px; }
    .grow { width: 100%; }
    .actions { white-space: nowrap; }
    .btn-link { background: none; border: none; color: #3598dc; cursor: pointer; padding: 0 6px; font-size: 12px; }
    .btn-link.danger { color: #e74a4e; }
  }
  .empty { text-align: center; color: #999; padding: 30px 0; }
  .modal-footer .close-btn {
    border-radius: 4px !important; background-color: #8b8787;
    padding: 7px 35px; font-weight: 600; color: #fff; border: none; height: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalManageCompanyTags.vue